import React from 'react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51907888972078:1';
export function HeroSection() {
  const handleCTAClick = () => {
    console.log('InitiateCheckout tracked');
  };
  return <section className="bg-gradient-to-br from-[#FAF7F2] via-[#F0E8DE] to-[#E8DDD0] min-h-screen flex items-center py-24 px-5 relative overflow-hidden" data-id="element-107">
      {/* Blurred background image */}
      <div className="absolute inset-0 z-0" data-id="element-108">
        <img src="https://cdn.magicpatterns.com/uploads/fxZyJxXuMXa1GdwMFThAnu/Imagen_16_9_vertical.png" alt="" className="w-full h-full object-cover blur-2xl scale-110 opacity-30" data-id="element-109" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#FAF7F2]/70 via-[#F0E8DE]/60 to-[#E8DDD0]/70 shadow-inner" data-id="element-110" />
      </div>

      <div className="absolute top-[-50%] right-[-20%] w-[600px] h-[600px] rounded-full bg-gradient-radial from-[rgba(183,110,121,0.08)] to-transparent pointer-events-none z-[1]" data-id="element-111" />

      <div className="max-w-[1100px] mx-auto grid md:grid-cols-2 gap-16 items-center w-full relative z-[2]" data-id="element-112">
        {/* Right side (image) - shows first on mobile */}
        <div className="relative order-first md:order-last flex flex-col gap-8" data-id="element-113">
          <div className="relative" data-id="element-114">
            <div className="rounded-3xl overflow-hidden shadow-2xl" data-id="element-115">
              <img src="https://cdn.magicpatterns.com/uploads/qPdt8MSEiEJtJa2aNfFhuW/ChatGPT_Image_31_mar_2026,_07_45_59_p.m..png" alt="Protocolo B.E.B.E. 365 — Su Primer Año" className="w-full object-cover" data-id="element-116" />
            </div>
            <div className="hidden md:block absolute bottom-[-15px] left-[-15px] bg-white rounded-xl p-3 shadow-xl font-sans text-center border-l-4 border-[#B76E79]" data-id="element-117">
              <strong className="block text-2xl text-[#B76E79]" data-id="element-118">+2,400</strong>
              <span className="text-[11px] text-gray-400" data-id="element-119">
                Familias ya lo aplican
              </span>
            </div>
          </div>
        </div>

        {/* Left side (content) */}
        <div className="text-center md:text-left" data-id="element-120">
          <span className="inline-block bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full mb-5 font-sans font-bold" data-id="element-121">
            ⭐ Protocolo B.E.B.E. 365 — Edición 2026
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl text-[#3D2B1F] leading-tight mb-4 font-bold" data-id="element-122">
            El <span className="text-[#B76E79]" data-id="element-123">Primer Año</span> De{' '}
            <span className="text-[#B76E79]" data-id="element-124">Tu Bebé</span> Es El Más
            Importante.
            <br data-id="element-125" />
            ¿Sabías Eso?
          </h1>

          <p className="text-lg md:text-xl text-[#6B4C3B] mb-8 italic leading-relaxed" data-id="element-126">
            El primer protocolo de neuro-arquitectura infantil que unifica
            sueño, estimulación cognitiva y nutrición en un solo sistema. Para
            padres que no crían por accidente.
          </p>

          <ul className="list-none mb-9 space-y-3.5 text-left" data-id="element-127">
            {['Tu bebé durmiendo 8 horas en tiempo récord', '52 actividades científicas para disparar su IQ', 'La guía nutricional que elimina los melindres para siempre', 'Acceso inmediato + 4 Bonos valorados en $138'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-base text-[#3D2B1F] font-sans" data-id="element-128">
                <span className="flex items-center justify-center w-5 h-5 rounded-full bg-[#B76E79] text-white text-xs font-bold flex-shrink-0 mt-0.5" data-id="element-129">
                  ✓
                </span>
                {item}
              </li>)}
          </ul>

          <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-[rgba(183,110,121,0.2)] mb-6" data-id="element-130">
            <div className="text-xs tracking-widest uppercase text-[#B76E79] font-sans font-bold mb-2" data-id="element-131">
              🔒 Descarga Digital Inmediata
            </div>
            <div className="text-lg text-gray-400 line-through font-sans mb-1" data-id="element-132">
              Valor total: $235
            </div>
            <div className="text-5xl md:text-6xl text-[#3D2B1F] font-bold leading-none mb-1.5" data-id="element-133">
              $14.97
            </div>
            <span className="inline-block bg-green-50 text-green-700 text-[13px] font-bold px-3 py-1 rounded-full font-sans" data-id="element-134">
              💰 Ahorras $220.03 hoy (94% OFF)
            </span>
            <p className="mt-3 text-xs text-[#6B4C3B] font-sans italic leading-relaxed" data-id="element-135">
              ¿Por qué solo $14.97? Porque es un producto digital y no tenemos
              costos de impresión o envío. Te trasladamos ese ahorro a ti.
            </p>
          </div>

          <a href={CHECKOUT_URL} onClick={handleCTAClick} className="block w-full bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-lg font-bold py-4 px-8 rounded-full text-center tracking-wide shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 font-sans uppercase mb-3 animate-cta-pulse" data-id="element-136">
            ⚡ SÍ, QUIERO ACCESO INMEDIATO POR $14.97 →
          </a>

          <div className="flex gap-5 flex-wrap text-xs text-gray-400 font-sans justify-center md:justify-start" data-id="element-137">
            <span className="flex items-center gap-1.5" data-id="element-138">
              🔒 Pago 100% Seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-139">
              🚫 Sin Suscripciones Ocultas
            </span>
            <span className="flex items-center gap-1.5" data-id="element-140">
              📥 Descarga Inmediata
            </span>
            <span className="flex items-center gap-1.5" data-id="element-141">
              ↩️ Garantía 30 Días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-142">
              💳 Visa · PayPal · Mastercard
            </span>
          </div>
        </div>
      </div>
    </section>;
}